exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.lang-switcher[data-v-39264ff6] {\n  width: 25px;\n}\n.lang-switcher_button[data-v-39264ff6] {\n  font-size: 12px;\n}\n.lang-switcher_button.grey[data-v-39264ff6] {\n  opacity: 0.6;\n}\n.lang-switcher_button.bold[data-v-39264ff6] {\n  font-weight: bold;\n}\n.lang-switcher_button--active[data-v-39264ff6] {\n  color: #00afa1;\n}\n.lang-switcher_button[data-v-39264ff6]:hover {\n  color: #00afa1;\n}", ""]);

// exports
